import { useRouter } from 'next/router';
import { BridgeContainer } from '@/components/BridgeContainer/BridgeContainer';
import { DeprecatedETHClaim } from './DeprecatedETHClaim';
import { FaucetClaim } from './FaucetClaim';
import { activeChainId } from '@/common';
import { garnetHolesky } from '@/chains/garnetHolesky';

const tabs = [
  {
    text: 'Faucet',
    link: '/faucet',
  },
  {
    text: 'Claim deprecated testnet ETH',
    link: '/claim-eth',
  },
];

export function FaucetClaimContainer() {
  const { route } = useRouter();
  return (
    <BridgeContainer tabs={activeChainId === garnetHolesky.id ? tabs : []}>
      <div className="w-full p-4">
        {route === '/faucet' && <FaucetClaim />}
        {route === '/claim-eth' && <DeprecatedETHClaim />}
      </div>
    </BridgeContainer>
  );
}
